import { useRouter } from "next/router";
import { GetServerSideProps } from "next/types";
import { SEO } from "../../components/seo/seo";
import { SellerInfoModule } from "../../modules/seller-info";
import {
  mapSellerProfileResultToSellerProfile,
  SellerProfile,
} from "../../stores/seller-store/seller-store.model";
import { isCrediMart, isCrediStore, normalizeUrl } from "../../utils/helper";
import { GetSellerProfileResult } from "../../utils/interfaces";

interface InfoPageProps {
  sellerData: SellerProfile;
}

const InfoPage = ({ sellerData }: InfoPageProps) => {
  const router = useRouter();
  return (
    <>
      <SEO
        title={
          sellerData
            ? `Informasi Toko ${sellerData?.User.name}`
            : "Toko tidak ditemukan"
        }
        description={
          sellerData && `${sellerData?.address}, Telp. ${sellerData?.User.phone}`
        }
        path={normalizeUrl(router.asPath)}
      />
      <SellerInfoModule sellerData={sellerData} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  try {
    const { seller: sellerUsername } = context.params;
    const sellerResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/guest/seller-profile?username=${sellerUsername}`
    );
    const sellerJson: GetSellerProfileResult = await sellerResponse.json();
    const sellerData = mapSellerProfileResultToSellerProfile(sellerJson);

    // restrict access by seller type
    if (
      !sellerData ||
      (isCrediMart() && !sellerData?.sellerJopan) ||
      (isCrediStore() && sellerData?.sellerJopan)
    ) {
      return {
        redirect: {
          permanent: false,
          destination: "/",
        },
      };
    }

    return {
      props: {
        sellerData,
      },
    };
  } catch (err) {
    return { props: {} };
  }
};

export default InfoPage;
